import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItemButton,
  ListItemText,

  Breadcrumbs,
  Link as MLink,
  Accordion,
  AccordionSummary,
  AccordionDetails,

  Container,
  TextField,

  Button,
} from "@mui/material";

import { Link } from "react-router-dom";

import "../../App.css";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { axiosInstance } from "../../Api/Axios/axios";
import { endpoints } from "../../Api/EndPoints/endpoints";
import { useNavigate } from "react-router-dom";

const leftMenu = ["ADDRESSES", "QUERY FORM"];

const QueryForm = () => {

  const [data, setData] = useState({})
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    email: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
    query: "",
  });
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 🔥 error clear for that field
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Cms Data fetch for Query Form

  const fetchContactData = async () => {
    try {

      const resData = await axiosInstance.get(endpoints.contactUs.cmsContact)
      setData(resData?.data?.data)

    }
    catch (err) {
      console.log(err)
    }
  }

  // Query Form Submit

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const res = await axiosInstance.post(endpoints.contactUs.queryForm, formData)

      navigate("/thankyou-page", {
        state: { formType: "Query Form" },
      });


      setFormData({
        first_name: "",
        last_name: "",
        mobile: "",
        email: "",
        country: "",
        state: "",
        city: "",
        pincode: "",
        address: "",
        query: "",
      });
      setErrors({}); // clear errors
    } catch (err) {
      console.log(err);

      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors); // 🔥 MAIN LINE
      }
    }
  };


  useEffect(() => {
    fetchContactData()
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <Box sx={{ padding: { xs: 2, md: 4 } }}>
      <Container maxWidth="xl">
        {/* Breadcrumb */}
        <Breadcrumbs sx={{ mb: 3, fontSize: "14px" }}>
          <MLink component={Link} to="/home" underline="hover" color="inherit">
            Home
          </MLink>
          <Typography color="inherit" sx={{ fontSize: "14px" }}>Contact Us</Typography>

          <Typography color="text.primary" sx={{ fontSize: "14px" }} >Query Form</Typography>
        </Breadcrumbs>

        {/* PAGE TITLE */}
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            mb: 1,
            color: "#000",
            textTransform: "uppercase",
            fontFamily: "Roboto",
          }}
        >
          CONTACT US
        </Typography>

        <Grid container spacing={3}>
          {/* Left Sidebar */}
          <Grid item size={{ xs: 12, md: 3 }}>


            <List sx={{ border: "1px solid #ddd" }}>
              {leftMenu.map((item) => (
                <ListItemButton
                  key={item}
                  component={Link}
                  to={`/contact/${item.toLowerCase().replace(/ /g, "-")}`}
                  sx={{
                    borderBottom: "1px solid #eee",

                    background:
                      item === "QUERY FORM"
                        ? "linear-gradient(125deg, #14b91d, #1171b0)"
                        : "transparent",

                    color: item === "QUERY FORM" ? "#fff" : "#000",

                    "&:hover": {
                      background:
                        item === "QUERY FORM"
                          ? "linear-gradient(125deg, #14b91d, #1171b0)"
                          : "#f5f5f5",
                    },

                    fontFamily: "Roboto",
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "Roboto",
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Grid>

          {/* Right Content Section */}
          <Grid item size={{ xs: 12, md: 9 }}>



            {/* Introduction */}


            <Accordion
              sx={{
                background: "#fff",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.10)",
                borderRadius: "8px",
                "&:before": { display: "none" },
                mt: 0,
                border: "1px solid #eee",
              }}
              defaultExpanded
            >
              <AccordionSummary
                sx={{
                  backgroundColor: "#f8f8f8",
                  borderBottom: "1px solid #eee",
                  borderRadius: "8px 8px 0 0",
                  minHeight: "60px",
                  "&.Mui-expanded": { minHeight: "60px" },
                }}
                expandIcon={
                  <ExpandMoreIcon sx={{ color: "#c00", fontSize: "28px" }} />
                }
              >
                <Typography
                  sx={{
                    fontSize: { md: "20px", xs: "16px" },
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  Contact Form
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{
                    p: { xs: 2, md: 3 },
                    background:
                      "linear-gradient(135deg, #fafafa 0%, #ffffff 100%)",
                    borderRadius: "0 0 8px 8px",
                  }}
                >
                  <Grid container spacing={3}>
                    {/* First Row */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          First Name <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Enter your first name"


                          error={!!errors.first_name} // 🔥 red border
                          helperText={errors.first_name?.[0]} // 🔥 error text


                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Last Name <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Enter your last name"

                          error={!!errors.last_name}
                          helperText={errors.last_name?.[0]}

                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        />
                      </Box>
                    </Grid>

                    {/* Second Row */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Mobile <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Enter mobile number"

                          error={!!errors.mobile}
                          helperText={errors.mobile?.[0]}

                          type="tel"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item size={{ xs: 12, md: 6 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Email <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Enter email address"

                          error={!!errors.email}
                          helperText={errors.email?.[0]}

                          type="email"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        />
                      </Box>
                    </Grid>

                    {/* Country Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Country <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Type your country"

                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        // InputProps={{
                        //   endAdornment: (
                        //     <InputAdornment position="end">
                        //       <SelectIcon
                        //         sx={{ color: "#666", cursor: "pointer" }}
                        //       />
                        //     </InputAdornment>
                        //   ),
                        // }}
                        />
                      </Box>
                    </Grid>

                    {/* State Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          State <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Type your state"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}

                        />
                      </Box>
                    </Grid>

                    {/* City Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          City <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Type your city"



                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}

                        />
                      </Box>
                    </Grid>

                    {/* Pincode Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Pincode <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          type="number"
                          name="pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Enter your pincode"

                          error={!!errors.pincode}
                          helperText={errors.pincode?.[0]}

                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}

                        />
                      </Box>
                    </Grid>

                    {/* Address Field */}
                    <Grid item size={{ xs: 12, md: 4 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Address <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          variant="outlined"
                          size="small"
                          placeholder="Type your address"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}

                        />
                      </Box>
                    </Grid>

                    {/* Query Field */}
                    <Grid item size={{ xs: 12 }}>
                      <Box sx={{ position: "relative" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#444",
                            fontSize: "14px",
                          }}
                        >
                          Write Your Query <span style={{ color: "#c00" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          name="query"
                          value={formData.query}
                          onChange={handleChange}
                          variant="outlined"
                          multiline
                          rows={4}
                          placeholder="Type your query here (maximum 500 characters)"
                          inputProps={{ maxLength: 500 }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "6px",
                              "&:hover fieldset": {
                                borderColor: "#c00",
                              },
                            },
                          }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 1,
                            px: 1,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "#666", fontSize: "12px" }}
                          >
                            Maximum 500 characters
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#666",
                              fontSize: "12px",
                              fontWeight: 500,
                            }}
                          >
                            0/500
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    {/* Verification Row */}


                    {/* Buttons */}
                    <Grid item size={{ xs: 12 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 3,
                          mt: 3,
                          pt: 2,

                        }}
                      >


                        <Button
                          variant="contained"
                          type="submit"
                          sx={{
                            alignSelf: { xs: "stretch", sm: "flex-start" },
                            px: { xs: 1.8, sm: 2.2, md: 2.4 },
                            py: { xs: 0.7, sm: 0.8 },
                            fontSize: { xs: "16px", sm: "17px" },
                            minWidth: "140px",

                            borderRadius: "6px",
                            textTransform: "none",
                            fontWeight: 600,

                            position: "relative",
                            overflow: "hidden",

                            background: "#bd2304",


                            zIndex: 1,

                            "& span": {
                              position: "relative",
                              zIndex: 2,
                            },


                            "&:before": {
                              content: '""',
                              position: "absolute",
                              left: "50%",
                              top: "50%",
                              width: 0,
                              height: 0,
                              background: "#000",
                              borderRadius: "50%",
                              transform: "translate(-12%, -50%)",
                              transition: "all 1s ease",
                              zIndex: 0,
                            },

                            "&:hover:before": {
                              width: "300%",
                              height: "300%",
                            },

                            "&:hover": {
                              background: "#bd2304",
                            },
                          }}

                        >
                          <span>Submit</span>
                        </Button>



                        <Button
                          variant="outlined"
                          sx={{
                            border: "2px solid #c00",
                            color: "#c00",
                            borderRadius: "6px",
                            padding: "6px 30px",
                            fontSize: "15px",
                            fontWeight: 600,
                            textTransform: "none",
                            "&:hover": {
                              borderColor: "#a00",
                              color: "#a00",
                              backgroundColor: "rgba(192,0,0,0.04)",
                              transform: "translateY(-1px)",
                            },
                            transition: "all 0.2s ease",
                            minWidth: "140px",
                          }}
                        >
                          Reset
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default QueryForm;
